import React from "react"
import { HStack, VStack, Text, Icon } from "@chakra-ui/react"
import { FaTriangleExclamation } from "react-icons/fa6"
import { DeleteButton } from "@hydrologiq/shared/content/components/Button"
import AssetLink from "../asset/AssetLink"

interface AssetItem {
  id: string
  name: string
}

interface SelectedAssetsListProps {
  assets: AssetItem[]
  unavailableAssetIds: string[]
  onRemove: (assetId: string) => void
  singleAsset?: boolean
}

/**
 * Displays a list of selected assets with remove buttons
 * Shows warning styling for unavailable assets
 * Pure presentational component with no business logic
 */
const SelectedAssetsList: React.FC<SelectedAssetsListProps> = ({
  assets,
  unavailableAssetIds,
  onRemove,
  singleAsset = false,
}) => {
  if (assets.length === 0) {
    return null
  }

  return (
    <VStack gap={2} align="stretch">
      <Text fontSize="sm" fontWeight="semibold">
        {singleAsset ? "Selected Asset" : `Selected Assets (${assets.length})`}
      </Text>
      {assets.map((asset) => {
        const isUnavailable = unavailableAssetIds.includes(asset.id)
        return (
          <HStack
            key={asset.id}
            justify="space-between"
            py={"20px"}
            px={"12px"}
            height="40px"
            bg={isUnavailable ? "red.50" : "bg.muted"}
            borderRadius="sm"
            borderColor={isUnavailable ? "red.300" : "transparent"}
          >
            <HStack gap={2}>
              {isUnavailable && (
                <Icon color="red.500" data-testid="warning-icon">
                  <FaTriangleExclamation />
                </Icon>
              )}
              <AssetLink asset={asset} openExternal={true} />
            </HStack>
            <DeleteButton onClick={() => onRemove(asset.id)} />
          </HStack>
        )
      })}
    </VStack>
  )
}

export default SelectedAssetsList
